import moment from 'moment-timezone';
import { getConfig } from '@config/runtimeConfig';

const COOKIE_STAGE = getConfig('COOKIE_STAGE');
const COOKIE_DOMAIN = getConfig('COOKIE_DOMAIN');

const STAGING_URI_EXT = COOKIE_STAGE === '_test' ? '.qa2' : '';

const isLocalhost = location.hostname === 'localhost' || location.hostname === '127.0.0.1';
const DOMAIN_STRING =
  !isLocalhost && COOKIE_DOMAIN ? `; domain=${STAGING_URI_EXT}${COOKIE_DOMAIN}` : '';
const ACCEPTANCE_STRING_RS = 'disclaimer-gpr';

export const logout = () => {
  document.cookie = `${ACCEPTANCE_STRING_RS}=; expires=Thu, 01 Jan 1970 00:00:00 UTC${DOMAIN_STRING}; path=/; SameSite=Lax`;
};

export const setDisclaimer = () => {
  const expireDate = moment().add(1, 'month').toDate().toUTCString();
  document.cookie = `${ACCEPTANCE_STRING_RS}=accepted; expires=${expireDate}${DOMAIN_STRING}; path=/; SameSite=Lax`;
};

export const getDisclaimer = () =>
  document.cookie
    .split(';')
    .find((e) => e.includes(`${ACCEPTANCE_STRING_RS}`))
    ?.split('=')[1];
